<template>
  <div class="z-50 fixed inset-0 bg-white flex justify-center items-center">
    <div>
      <div class="flex divide-x">
        <div class="px-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-24 text-cyan-600"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="px-6">
          <h2 class="text-5xl font-bold text-gray-900">ขออภัยในความไม่สะดวก</h2>
          <p class="text-xl font-medium text-gray-500">
            เนื่องจากอยู่ระหว่างการปรับปรุงระบบชั่วคราว
          </p>
          <div class="mt-8">
            <button
              type="button"
              class="
                px-4
                py-2
                border border-transparent
                rounded-md
                shadow-sm
                font-medium
                text-cyan-700
                bg-cyan-100
                hover:bg-cyan-200
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
              "
            >
              ติดต่อเจ้าหน้าที่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
}
</script>
